module.exports = __webpack_public_path__ + "img/vote2026ico.71ba6b76.png";